<template>
  <div class="container">蔚青云智慧融媒平台</div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: '首页',
      meta: [
        {
          name: 'keywords',
          content: '',
        },
        {
          name: 'description',
          content: '',
        },
      ],
    }
  },
  name: '',
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="less" scoped>
.container {
}
</style>
